var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cityLocation"},[_c('div',{staticClass:"areaMap"},[_c('block-ye',{attrs:{"cate":1,"polygondata":_vm.polygondata}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }